"use strict";
/* eslint-disable functional/no-classes */
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearQuarter = void 0;
const LocalDate_1 = require("./LocalDate");
const LocalDateInterval_1 = require("./LocalDateInterval");
/**
 * Represents a year quarter.
 */
class YearQuarter {
    year;
    quarter;
    //
    // CONSTRUCTORS
    //
    /**
     * Creates a new YearQuarter instance from a LocalDate instance.
     */
    static fromLocalDate(date) {
        const quarter = Math.floor((date.month - 1) / 3) + 1;
        return new YearQuarter(date.year, quarter);
    }
    /**
     * Creates a new YearQuarter instance.
     *
     * @param year Year
     * @param quarter Quarter
     */
    constructor(year, quarter) {
        this.year = year;
        this.quarter = quarter;
        // eslint-disable-next-line functional/no-expression-statements
        this.quarter = ((quarter - 1) % 4) + 1;
        // eslint-disable-next-line functional/no-expression-statements
        this.year = year + Math.floor((quarter - 1) / 4);
    }
    //
    // COMPARISONS
    //
    /**
     * Returns whether the given year quarter is equal to this year quarter.
     *
     * @param other Year quarter to compare
     * @returns Whether the given year quarter is equal to this year quarter
     */
    isEqual(other) {
        return this.year === other.year && this.quarter === other.quarter;
    }
    /**
     * Returns whether the given year quarter is before this year quarter.
     *
     * @param other Year quarter to compare
     * @returns Whether the given year quarter is before this year quarter
     */
    isBefore(other) {
        return (this.year < other.year ||
            (this.year === other.year && this.quarter < other.quarter));
    }
    /**
     * Returns whether the given year quarter is after this year quarter.
     *
     * @param other Year quarter to compare
     * @returns Whether the given year quarter is after this year quarter
     */
    isAfter(other) {
        return (this.year > other.year ||
            (this.year === other.year && this.quarter > other.quarter));
    }
    /**
     * Compares this year quarter to the given year quarter.
     *
     * @param other Year quarter to compare
     * @returns 0 if the year quarters are equal, -1 if this year quarter is before the given year quarter, 1 if this year quarter is after the given year quarter
     */
    compare(other) {
        if (this.isEqual(other)) {
            return 0;
        }
        if (this.isBefore(other)) {
            return -1;
        }
        return 1;
    }
    //
    // TRANSFORMERS
    //
    /**
     * Returns the first day of the quarter for the given date
     *
     * @param date Date to get the first day of the quarter for
     * @returns First day of the quarter
     */
    firstDay() {
        const firstMonthOfQuarter = (this.quarter - 1) * 3 + 1;
        return new LocalDate_1.LocalDate(this.year, firstMonthOfQuarter, 1);
    }
    /**
     * Returns the last day of the quarter for the given date
     *
     * @param date Date to get the last day of the quarter for
     * @returns Last day of the quarter
     */
    lastDay() {
        const zeroBasedFirstMonthOfNextQuarter = this.quarter * 3;
        const lastDay = new Date(Date.UTC(this.year, zeroBasedFirstMonthOfNextQuarter, 1 - 1 // previous day of first day of next quarter === last day of the last month of the quarter
        ));
        return LocalDate_1.LocalDate.fromDateUTC(lastDay);
    }
    /**
     * Returns the date range for the quarter
     */
    interval() {
        return new LocalDateInterval_1.LocalDateInterval(this.firstDay(), this.lastDay().plusDays(1));
    }
    /**
     * Formats the quarter like "Q1 2021".
     */
    toQuarterLabel() {
        return `Q${this.quarter} ${this.year}`;
    }
}
exports.YearQuarter = YearQuarter;
